module.exports = {
  domain: {
    desktop: "www.perf.use2.racing.fndlext.net",
    mobile: "www.perf.use2.racing.fndlext.net",
    talentPicks: "www.perf.use2.racing.fndlext.net/talent-picks/",
    accountWallet: "account.racing.perf.use2.racing.fndlext.net",
    equibase: "equibase-store.perf.use2.racing.fndlext.net"
  },
  recaptchaID: "6Lf-4hUqAAAAAGupa6W70kpZVsaFd7yaxz5pHD8r",
  recaptchaIdNative: "6Le9B1YqAAAAAJEWJZsQittPtHDcjz6xLNORgHyI"
};
